// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { visualFormSelectItems } from "#/admin/legacy/sp-select/visual-form-select-items.js";
import { spSelectSearchable } from "#/admin/legacy/sp-select/index.js";

const OPTION_SOURCES = Object.freeze({
  sex: "options",
  trait: "options",
  organizational_unit: "options",
  location_selector: "options",
  contact: "relationship_types",
  disposition: "dispositions",
  journey_subject: "journey_subjects",
});
const BLANK_FIRST_TYPES = Object.freeze(["sex", "trait", "disposition", "journey_subject"]);

/**
 * Returns a copy of a choice field with its preview `select_items`, or the field itself when it has no choices. A type
 * with fixed choices previews them over the field's own options.
 */
export function previewSelectItems(field, fixedChoiceOptions = {}) {
  const source = OPTION_SOURCES[field.type];

  if (!source) {
    return field;
  }

  const options = fixedChoiceOptions[field.type] ?? field[source];
  const items = visualFormSelectItems(options, {
    includeBlank: BLANK_FIRST_TYPES.includes(field.type),
    nested: field.type === "location_selector",
  });

  return {
    ...field,
    select_items: items,
    select_searchable: spSelectSearchable(items),
  };
}
